import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { createFocusTrap, FocusTrap } from 'focus-trap';
import moveFocus from '../../../javascripts/utils/moveFocus';

const eventCalendars =
  document.querySelectorAll<HTMLElement>('.event-calendar');

eventCalendars.forEach((eventCalendar) => {
  const months = eventCalendar.querySelectorAll<HTMLElement>(
    '.event-calendar__month',
  );
  const stickyBar = eventCalendar.querySelector<HTMLElement>(
    '.event-calendar__sticky-bar',
  );

  if (!stickyBar) return;

  const stickyBarOverlay = stickyBar.querySelector<HTMLElement>(
    '.event-calendar__sticky-bar-overlay',
  );
  const stickyBarOpenButton = stickyBar.querySelector<HTMLButtonElement>(
    '[data-open-filter-button]',
  );
  const stickyBarCloseButton = stickyBar.querySelector<HTMLButtonElement>(
    '[data-close-filter-button]',
  );

  let focusTrap: FocusTrap | undefined;

  stickyBarOpenButton?.addEventListener('click', () => {
    if (!stickyBarOverlay) return;

    stickyBarOverlay.dataset.open = '';

    focusTrap = createFocusTrap(stickyBarOverlay, {
      escapeDeactivates: true,
      allowOutsideClick: false,
      initialFocus: false,
      returnFocusOnDeactivate: false,
      onActivate() {
        moveFocus(stickyBarOverlay);
        disableBodyScroll(stickyBarOverlay);
      },
      onDeactivate() {
        delete stickyBarOverlay.dataset.open;
        enableBodyScroll(stickyBarOverlay);
        focusTrap = undefined;
      },
    });

    focusTrap.activate();
  });

  stickyBarCloseButton?.addEventListener('click', (e: MouseEvent) => {
    e.preventDefault();
    focusTrap?.deactivate();
  });

  let stickyBarHeadline =
    stickyBar.querySelector<HTMLElement>('.headline__text');
  if (stickyBarHeadline?.firstChild)
    stickyBarHeadline = stickyBarHeadline.firstChild as HTMLElement;

  if (!stickyBarHeadline || !months.length) return;

  function setStickybarLabel() {
    if (!stickyBarHeadline || !months.length) return;

    let label;

    // eslint-disable-next-line no-restricted-syntax
    for (const month of months) {
      const { top, height } = month.getBoundingClientRect();
      // eslint-disable-next-line no-continue
      if (!height) continue;
      if (top < 0) {
        label = month.dataset.label;
      } else {
        if (!label) label = month.dataset.label;
        break;
      }
    }

    stickyBarHeadline.textContent = label || '';
  }

  window.addEventListener('scroll', setStickybarLabel);
  setStickybarLabel();

  function updateVisibleEvents(currentFilter: typeof filter) {
    const events =
      eventCalendar.querySelectorAll<HTMLElement>('.event-card--event');

    // eslint-disable-next-line no-restricted-syntax
    for (const event of events) {
      let hide = false;
      if (currentFilter.month && event.dataset.month !== currentFilter.month)
        hide = true;
      if (
        currentFilter.location &&
        event.dataset.location !== currentFilter.location
      )
        hide = true;
      if (
        currentFilter.category &&
        event.dataset.category !== currentFilter.category
      )
        hide = true;

      if (hide) event.dataset.hidden = '';
      else delete event.dataset.hidden;
    }

    setStickybarLabel();
  }

  const filter = {
    month: null,
    location: null,
    category: null,
  } as {
    month: null | string;
    location: null | string;
    category: null | string;
  };

  eventCalendar.addEventListener(
    'filter-month',
    (event: CustomEventInit<string | null>) => {
      filter.month = event.detail || null;
      filter.location = null;
      filter.category = null;
      updateVisibleEvents(filter);
    },
  );

  eventCalendar.addEventListener(
    'filter-location',
    (event: CustomEventInit<string | null>) => {
      filter.month = null;
      filter.location = event.detail || null;
      filter.category = null;
      updateVisibleEvents(filter);
    },
  );

  eventCalendar.addEventListener(
    'filter-category',
    (event: CustomEventInit<string | null>) => {
      filter.month = null;
      filter.location = null;
      filter.category = event.detail || null;
      updateVisibleEvents(filter);
    },
  );
});
